import './VideoWithTextBlock.scss';
import { createApp, defineAsyncComponent } from 'vue';

const mountingVideoWithTextBlocks = document.querySelectorAll('[data-video-with-text]');

if (mountingVideoWithTextBlocks) {
	mountingVideoWithTextBlocks.forEach((block) => {
		const VideoWithTextBlockVue = defineAsyncComponent(
			() => import('./VideoWithTextBlock.vue')
		);

		const app = createApp({
			name: 'VideoWithTextApp',
		});
		app.component('video-with-text-block', VideoWithTextBlockVue);
		app.mount(block);
	});
}